// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_YtE","cls2":"ProfileDropdown-cls2_tBW ProfileDropdown-cls1_YtE"};